import path from "path";
import UserEntity from "../../domain/entities/UserEntity";
import SignInPage from "../pages/auth/signin/SignInPage";
import CreateUserPage from "../pages/users/create/CreateUserPage";
import DetailedUserPage from "../pages/users/detailed/DetailedUserPage";
import DashboardPage from "../pages/home/DashboardPage";
import HumanAgentListPage from "../pages/users/list/user_list.page";
import StablishmentListPage from "../pages/stablishments/list/stablishment_list.page";
import CreateStablishmentPage from "../pages/stablishments/create/CreateStablishmentPage";
import ShiftListPage from "../pages/shifts/list/shift_list.page";
import CreateShiftPage from "../pages/shifts/create/CreateShiftPage";
import QrListPage from "../pages/qrs/list/qr_list.page";
import CreateQrPage from "../pages/qrs/create/CreateQrPage";
import ValetReportPage from "../pages/reports/valet/valet_report.page";

export interface RouteEntity {
    path: string;
    relativePath: string;
    component: any;
    auth: (user: UserEntity | undefined | null) => boolean;
    title?: string;
    relativePathWithParams?: (params: any) => string;
};
const routes = {
    login: {
        path: "/",
        relativePath: "/",
        component: SignInPage,
        auth: (user: UserEntity | undefined | null) => !user,
        title: "Login",
        relativePathWithParams: (params: any) => "/",
    },
    home: {
        path: "/dashboard",
        relativePath: "/dashboard",
        component: DashboardPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Dashboard",
        relativePathWithParams: (params: any) => "/dashboard",
    },
    user_list: {
        path: "/usuarios",
        relativePath: "/usuarios",
        component: HumanAgentListPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Usuarios",
        relativePathWithParams: (params: any) => "/usuarios",
    },
    user_create: {
        path: "/users/create",
        relativePath: "/users/create",
        component: CreateUserPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Create User",
        relativePathWithParams: (params: any) => "/users",
    },
    edit_user: {
        path: "/users/edit/:id",
        relativePath: "/users/edit",
        component: CreateUserPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Edit User",
        relativePathWithParams: (params: {id: string}) => `/users/edit/${params.id}`,
    },
    user: {
        path: "/users/:id",
        relativePath: "/users",
        component: DetailedUserPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "User",
        relativePathWithParams: (params: {id: string}) => `/users/${params.id}`,
    },
    stablishment_list: {
        path: "/establecimientos",
        relativePath: "/establecimientos",
        component: StablishmentListPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Establecimientos",
        relativePathWithParams: (params: any) => "/establecimientos",
    },
    stablishment_create: {
        path: "/establecimientos/crear",
        relativePath: "/establecimientos/crear",
        component: CreateStablishmentPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Crear Establecimiento",
        relativePathWithParams: (params: any) => "/establecimientos/crear",
    },
    edit_stablishment: {
        path: "/establecimientos/editar/:id",
        relativePath: "/establecimientos/editar",
        component: CreateStablishmentPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Editar Establecimiento",
        relativePathWithParams: (params: {id: string}) => `/establecimientos/editar/${params.id}`,
    },
    shift_list: {
        path: "/turnos",
        relativePath: "/turnos",
        component: ShiftListPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Turnos",
        relativePathWithParams: (params: any) => "/turnos",
    },
    shift_create: {
        path: "/turnos/crear",
        relativePath: "/turnos/crear",
        component: CreateShiftPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Crear Turno",
        relativePathWithParams: (params: any) => "/turnos/crear",
    },
    edit_shift: {
        path: "/turnos/editar/:id",
        relativePath: "/turnos/editar",
        component: CreateShiftPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Editar Turno",
        relativePathWithParams: (params: {id: string}) => `/turnos/editar/${params.id}`,
    },
    qr_list: {
        path: "/qrs",
        relativePath: "/qrs",
        component: QrListPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "QRs",
        relativePathWithParams: (params: any) => "/qrs",
    },
    qr_create: {
        path: "/qrs/create",
        relativePath: "/qrs/create",
        component: CreateQrPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Crear QRs",
        relativePathWithParams: (params: any) => "/qrs/create",
    },
    valet_report: {
        path: "/reportes/valet",
        relativePath: "/reportes/valet",
        component: ValetReportPage,
        auth: (user: UserEntity | undefined | null) => user != null,
        title: "Reporte de Valet",
        relativePathWithParams: (params: any) => "/reportes/valet",
    }
};

export default routes;